import { createUseStyles } from 'react-jss'

import { smartWordWrapMixin } from '../../../../../../styles/mixins/common'

const useStyles = createUseStyles({
  name: {
    ...smartWordWrapMixin()
  }
})

export default useStyles
